import classNames from 'classnames';
import React from 'react';
import { Box } from '@wix/design-system';
import s from './ProductsGrid.scss';
import { CollapsibleGrid, } from './components/CollapsibleGrid/CollapsibleGrid';
import { GridHeader, } from './components/GridHeader/GridHeader';
import { Z_INDEX } from './consts';
export const ProductsGridContext = React.createContext({
    handleGridHeaderResize: () => { },
    setMarginTop: () => { },
});
export const ProductsGrid = ({ children, productsCount, innerRef, dataHook, className, }) => {
    const [gridHeaderHeight, setGridHeaderHeight] = React.useState(0);
    const [marginTop, setMarginTop] = React.useState(0);
    const gridCustomProperties = {
        '--gridColumns': productsCount,
        '--gridMarginTop': marginTop,
        '--gridHeaderHeight': gridHeaderHeight,
    };
    const handleGridHeaderResize = (entry) => {
        const { height } = entry.target.getBoundingClientRect();
        if (height !== gridHeaderHeight) {
            setGridHeaderHeight(height);
        }
    };
    return (React.createElement(ProductsGridContext.Provider, { value: {
            setMarginTop: (value) => setMarginTop(value),
            handleGridHeaderResize,
        } },
        React.createElement(Box, { className: s.root, dataHook: dataHook, direction: "vertical", backgroundColor: "white" },
            React.createElement(Box, { height: marginTop, backgroundColor: "white", position: "sticky", top: "0", zIndex: Z_INDEX.GRID_HEADER }),
            React.createElement("div", { className: classNames(s.grid, className), ref: innerRef, style: gridCustomProperties }, children))));
};
ProductsGrid.Header = GridHeader;
ProductsGrid.Collapsible = CollapsibleGrid;
//# sourceMappingURL=ProductsGrid.js.map